/** @jsx jsx */
import { jsx, Heading, useColorMode } from "theme-ui"
import { MDXRenderer } from "gatsby-plugin-mdx"
import Layout from "./layout"
import SEO from "./seo"
import ColorModeToggle from "./colormode-toggle"

type PageProps = {
  data: {
    page: {
      title: string
      slug: string
      excerpt: string
      body: string
    }
  }
}

const px = [`32px`, `16px`, `8px`, `4px`]
const shadow = px.map((v) => `rgba(0, 0, 0, 0.15) 0px ${v} ${v} 0px`)

const Page = ({ data: { page } }: PageProps) => {
  const [colorMode, setColorMode] = useColorMode()
  const isDark = colorMode === `dark`
  const toggleColorMode = (e: any) => {
    e.preventDefault()
    setColorMode(isDark ? `light` : `dark`)
  }
  return (
  <Layout>
    <div 
      sx={{ borderRadius: `50px`, 
            background: isDark ? `#313949` :`#eeeeee`,
            boxShadow: isDark ? `9px 9px 30px #292f3d, -9px -9px 30px #394355` : `9px 9px 28px #e0e0e0, -9px -9px 28px #fcfcfc`,
            padding: `10px 50px 10px 50px`,
            marginBottom: `100px`
          }}
      >
      <SEO title={page.title} description={page.excerpt} />
      <Heading variant="styles.h2">{page.title}</Heading>
      <section sx={{ my: 5, ".gatsby-resp-image-wrapper": { my: [4, 4, 5], boxShadow: shadow.join(`, `) } }}>
        <MDXRenderer>{page.body}</MDXRenderer>
    </section>
    </div>
  </Layout>
  )
}

export default Page
